/* AeroSims, Seite "So funktioniert es" (Sektion how-it-works-premium, Snippets as-hiw-<locale>).
   Die Seite funktioniert ohne dieses Skript vollstaendig: die OS-Reiter laufen ueber Radios und :has(),
   alle Texte stehen serverseitig im HTML. Dieses Skript ergaenzt nur:
     1. Merken der OS-Wahl (localStorage)
     2. Video wird erst auf Klick von YouTube geladen (youtube-nocookie)
     3. aktiver Punkt in der Sprungleiste
     4. Fortschritt der Checkliste, Haken ueberleben einen Reload (sessionStorage)
   Init ist idempotent und haengt an DOMContentLoaded, shopify:section:load und pageshow. */
(function () {
  'use strict';
  var OS_KEY = 'as_hiw_os';
  var CHK_KEY = 'as_hiw_checks';

  function osSync(root) {
    var ins = root.querySelectorAll('.hiw-os__in');
    if (!ins.length) return;
    /* Das Inline-Skript im Snippet hat bereits vor dem ersten Zeichnen gesetzt.
       Hier nur nachziehen, falls es nicht lief, und die Wahl merken. */
    var checked = root.querySelector('.hiw-os__in:checked');
    if (!checked) {
      var saved = null;
      try { saved = localStorage.getItem(OS_KEY); } catch (e) { }
      var ua = navigator.userAgent || '';
      var os = saved || (/iPhone|iPad|iPod/.test(ua) ? 'iphone' : /SM-|Samsung/i.test(ua) ? 'samsung' : /Android/.test(ua) ? 'android' : 'iphone');
      var el = document.getElementById('hiw-os-' + os);
      if (el) el.checked = true;
    }
    Array.prototype.forEach.call(ins, function (i) {
      if (i.dataset.hiwReady) return;
      i.dataset.hiwReady = '1';
      i.addEventListener('change', function () {
        if (!i.checked) return;
        try { localStorage.setItem(OS_KEY, i.getAttribute('data-os') || ''); } catch (e) { }
      });
    });
  }

  function videos(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-hiw-video]'), function (box) {
      if (box.dataset.hiwReady) return;
      box.dataset.hiwReady = '1';
      var btn = box.querySelector('[data-hiw-play]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = box.getAttribute('data-hiw-video') || '';
        if (!/^[A-Za-z0-9_-]{6,20}$/.test(id)) return;
        var lang = box.getAttribute('data-hiw-lang') || 'en';
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1&hl=' + encodeURIComponent(lang) +
          '&cc_lang_pref=' + encodeURIComponent(lang) + '&cc_load_policy=1';
        f.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        var stage = box.querySelector('[data-hiw-stage]') || box;
        stage.innerHTML = '';
        stage.appendChild(f);
      });
    });
  }

  function jump(root) {
    var nav = root.parentNode ? root.parentNode.querySelector('[data-hiw-jump]') : null;
    if (!nav) nav = root.querySelector('[data-hiw-jump]');
    if (!nav || nav.dataset.hiwReady) return;
    nav.dataset.hiwReady = '1';
    var pairs = [];
    Array.prototype.forEach.call(nav.querySelectorAll('a[href^="#"]'), function (a) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t) pairs.push({ a: a, t: t });
    });
    if (!pairs.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        pairs.forEach(function (p) { p.a.classList.toggle('is-on', p.t === en.target); });
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    pairs.forEach(function (p) { io.observe(p.t); });
  }

  function checklist(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-hiw-check]'), function (list) {
      if (list.dataset.hiwReady) return;
      list.dataset.hiwReady = '1';
      var boxes = list.querySelectorAll('input[type=checkbox]');
      var saved = '';
      try { saved = sessionStorage.getItem(CHK_KEY) || ''; } catch (e) { }
      Array.prototype.forEach.call(boxes, function (b, i) { if (saved.charAt(i) === '1') b.checked = true; });
      list.addEventListener('change', function () {
        var s = '';
        Array.prototype.forEach.call(boxes, function (b) { s += b.checked ? '1' : '0'; });
        try { sessionStorage.setItem(CHK_KEY, s); } catch (e) { }
      });
    });
  }

  function init() {
    var root = document.querySelector('.hiw');
    if (!root) return;
    osSync(root);
    videos(root);
    jump(root);
    checklist(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
